import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Less_xs = (props) => {
    const width = props.width ? props.width + 'px' : '16px';
    const height = props.height ? props.height + 'px' : '16px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 16 16"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.25 8C14.25 8.41421 13.9142 8.75 13.5 8.75L2.5 8.75C2.08579 8.75 1.75 8.41421 1.75 8C1.75 7.58579 2.08579 7.25 2.5 7.25L13.5 7.25C13.9142 7.25 14.25 7.58579 14.25 8Z"
            />
        </SvgStyled>
    );
};

export default Less_xs;
